import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=23720286&"
import script from "./tree.js?vue&type=script&lang=js&"
export * from "./tree.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports